jQuery(document).ready(function($) {
	mobileMenu();
});

function mobileMenu() {
	let menuToggleBar = document.querySelector('.m-main_nav__toggle');
	let menuButton = menuToggleBar.querySelector('.a-main_nav__toggle__button');
	let menuDrawer = document.querySelector('.o-header-main-menu');
	
	menuButton.classList.remove('open');
	menuDrawer.classList.remove('open');
	

	if (menuToggleBar) {
		if (true) { // if menuToggleBar.offsetParent !== null
			const toggleMenu = drawer => {
				drawer.classList.toggle('open');
			};

			const toggleMenuClose = drawer => {
				drawer.classList.toggle('open');
			};

			function functionToggleMenu(evt) {
				evt.preventDefault();
				toggleMenu(menuDrawer);
				toggleMenuClose(menuButton);
			}

			menuButton.addEventListener('click', functionToggleMenu, true );
			

			/**
			 * Mobile menu functionality
			 */
			let firstLevelParents = menuDrawer.querySelectorAll('.a-main_nav__link--parent');

			firstLevelParents.forEach(parent => {
				let secondLevelLists = parent.querySelectorAll('.m-main_nav__links_list__child_list');
				let titles = parent.querySelectorAll('.a-main_nav__title');
				let backs = parent.querySelectorAll('.a-main_nav__title__back');

				backs.forEach(back => {
					let siblings = back.parentNode.children;

					back.addEventListener('click', function(e) {
						e.preventDefault();
						parent.classList.remove('open');

						for ( let sibling of siblings ) {
							sibling.classList.remove('open');
						}
					});

					window.addEventListener('resize', function() {
						parent.classList.remove('open');
						for ( let sibling of siblings ) {
							sibling.classList.remove('open');
						}
					});
				});

				titles.forEach(title => {
					let siblings = parent.parentNode.children;

					title.addEventListener('click', function(e) {
						if ( !parent.classList.contains('open') ) {
							e.preventDefault();

							for (let sibling of siblings) {
								if (sibling !== parent) {
									let siblingLists = sibling.querySelectorAll('.m-main_nav__links_list__child_list');
									siblingLists.forEach(list => {
										if (list.classList.contains('open')) {
											list.classList.remove('open');
											parent.classList.remove('open');

										}
									});
								}
							}
							title.nextElementSibling.classList.toggle('open');
							parent.classList.toggle('open');
						}
					});
				});
				secondLevelLists.forEach(list => {
					let childLists = list.querySelectorAll('.no-link');
					for (let child of childLists) {
						child.addEventListener('click', e => {
							child.classList.toggle('open');
							let subList = child.querySelector(
								'.m-main_nav__links_list__child_list--sublist'
							);
							subList.classList.toggle('open');
						});
					}
				});
			});
		}
	}
}
